import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addFollowup,
  getFollowups,
  getFollowup,
  editFollowup,
  deleteFollowup,
  getAllFollowups,
} from "../../store/actions/followup_action";
import { SEARCH_TERMS } from "../enums/followups_enum";
// Get All Data
export const useAllFollowups = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.followup);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteFollowup(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getFollowups({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      } else {
        dispatch(
          getFollowups({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getFollowups({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleFollowup = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.followup);
  useEffect(() => {
    dispatch(getFollowup(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateFollowup = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addFollowup(data));
  };
  return [addData];
};
export const useUpdateFollowup = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editFollowup(id, data));
  };
  return [updateData];
};

export const useSelectAllFollowup = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.followup);
    useEffect(() => {
      dispatch(getAllFollowups());
    }, []);
    return [data];
  };      